import { asyncRoutes, constantRoutes } from '@/router'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {

	if(roles.indexOf(route.meta.menuCode) != -1) {
		return true;
	}
	return false;
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */

export function filterAsyncRoutes(routes, roles) {
	const res = []
	routes.forEach(route => {
		const tmp = { ...route
		}
		if(tmp.meta && tmp.meta.menuCode) {
			if(hasPermission(roles, tmp)) {
				res.push(tmp);
			}
		}

	})

	return res
}

export function filterMenuTxt(routes, roles) {
	const menuTxt = []
	//['订单中心#P1', '我的钱包#P2', '会员中心#P3', '我的业务#P4', '我的收藏#P5'];
	var rootMenu = ['订单中心#P1', '我的钱包#P2', '统计报表#P14', '会员中心#P3', '我的收藏#P5'];
	for(var g in rootMenu) {
		var children = [];
		var s = rootMenu[g].split('#');
		var r = {
			title: s[0],
			code: s[1],
			children: []
		}
		if(roles.indexOf(s[1]) != -1) {
			menuTxt.push(r);
		}

	}
	routes.forEach(route => {
		const tmp = { ...route
		}
		if(tmp.meta && tmp.meta.menuCode) {
			if(hasPermission(roles, tmp)) {
				if(tmp.meta.parentCode != undefined) {
					for(var h in menuTxt) {
						if(menuTxt[h].code == tmp.meta.parentCode) {
							menuTxt[h].children.push(tmp);
						}
					}
				}
			}
		}

	})
    console.log(menuTxt);

	return menuTxt
}
const state = {
	routes: [],
	addRoutes: [],
	menuTxt: []
}

const mutations = {
	SET_ROUTES: (state, routes) => {
		state.addRoutes = routes
		state.routes = constantRoutes.concat(routes)
	},
	SET_MENUTXT: (state, menuTxt) => {
		state.menuTxt = menuTxt
	}
}

const actions = {
	generateRoutes({
		commit
	}, roles) {
		return new Promise(resolve => {

			let accessedRoutes, menuTxt
			accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
			menuTxt = filterMenuTxt(asyncRoutes, roles)
			commit('SET_ROUTES', accessedRoutes)
			commit('SET_MENUTXT', menuTxt)
			resolve(accessedRoutes)
			resolve(menuTxt)
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
